// extracted by mini-css-extract-plugin
module.exports = {"dark":"DarkModeToggle-module--dark--1PwXj"};